import calculation from '@/application/lib/calculations'

export default {
    data() {
        return {
            enableTaxes: true,
        }
    },
    async created() {
        const config = await this.$gestios.config.list(['enableTaxes'])
        this.enableTaxes = config.data.enableTaxes === '0' ? false : true
    },
    computed: {
        totalCalculations() {
            return calculation.totals(this.conceptCalculation)
        },

        conceptCalculation() {
            const calcs = {}
            let surcharge = this.clientSurcharge

            Object.keys(this.fields.concepts).forEach((key) => {
                const concept = this.fields.concepts[key]

                calcs[key] = calculation.concept({
                    price: concept.price,
                    quantity: concept.quantity,
                    discount: concept.discount,
                    iva: this.enableTaxes ? concept.iva : 0,
                    surcharge: this.enableTaxes ? surcharge : 0,
                })
            })

            return calcs
        },
    },
}
